export default __webpack_public_path__ + "static/media/13.d11a6b6a.jpg";